import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../api/client.js";
import { clearAdminToken, getAdminToken } from "./auth.js";

function ProtectedAdminRoute({ children }) {
  const location = useLocation();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = getAdminToken();

    if (!token) {
      setState("denied");
      return undefined;
    }

    const controller = new AbortController();

    api.admin
      .me(token, { signal: controller.signal })
      .then(() => setState("allowed"))
      .catch((error) => {
        if (error.name !== "AbortError") {
          clearAdminToken();
          setState("denied");
        }
      });

    return () => controller.abort();
  }, []);

  if (state === "checking") {
    return <div className="admin-route-loading">Verifying admin access…</div>;
  }

  if (state === "denied") {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}

export default ProtectedAdminRoute;
